import HttpService from '../base.service/HttpService'

export default class MonitoringRevenueService extends HttpService {
  getMonitoringPln (param) {
    const api = process.env.VUE_APP_API + '/revenue/monitoring/pln'
    return this.get(param, api)
  }

  getMonitoringPartner (param) {
    const api = process.env.VUE_APP_API + '/revenue/monitoring/partner'
    return this.get(param, api)
  }

  getUnitList (param) {
    const api = process.env.VUE_APP_API + '/revenue/monitoring/unit-list'
    return this.get(param, api)
  }
}
